'use strict';

class MemoryStore {
  constructor() {
    this.memoryStore = {};
  }

  getItem(key) {
    return this.memoryStore[key] || null;
  }

  setItem(key, value) {
    this.memoryStore[key] = value;
  }

  removeItem(key) {
    delete this.memoryStore[key];
  }
}

export default MemoryStore;
